export const FREE_SUBMISSION_ALLOWANCE = 150;
export const FREE_ENDPOINT_ALLOWANCE = 10;
export const BASE_SUBMISSION_RATE = 0.02;
export const ENDPOINT_BLOCK_SIZE = 100;
export const ENDPOINT_BLOCK_PRICE = 10;

function getEffectiveRate(submissionsCount) {
  if (submissionsCount > 25000) return BASE_SUBMISSION_RATE * 0.5;
  if (submissionsCount > 5000) return BASE_SUBMISSION_RATE * 0.75;
  if (submissionsCount > 1000) return BASE_SUBMISSION_RATE * 0.9;
  return BASE_SUBMISSION_RATE;
}

function getVolumeDiscountLabel(submissionsCount) {
  if (submissionsCount > 25000) return '50% volume discount';
  if (submissionsCount > 5000) return '25% volume discount';
  if (submissionsCount > 1000) return '10% volume discount';
  return null;
}

export function calculateMonthlyCost(submissionsCount = 0, endpointCount = 0) {
  const submissions = Math.max(0, Math.floor(Number(submissionsCount) || 0));
  const endpoints = Math.max(0, Math.floor(Number(endpointCount) || 0));

  const effectiveRate = getEffectiveRate(submissions);
  const billedSubmissions = Math.max(0, submissions - FREE_SUBMISSION_ALLOWANCE);
  const submissionCost = billedSubmissions * effectiveRate;
  const submissionDiscount = billedSubmissions * BASE_SUBMISSION_RATE - submissionCost;

  const paidBlocks =
    endpoints <= FREE_ENDPOINT_ALLOWANCE ? 0 : Math.ceil(endpoints / ENDPOINT_BLOCK_SIZE);
  const endpointCost = paidBlocks * ENDPOINT_BLOCK_PRICE;

  return {
    submissions,
    endpoints,
    billedSubmissions,
    submissionCost,
    submissionDiscount,
    effectiveRate,
    volumeDiscountLabel: getVolumeDiscountLabel(submissions),
    paidBlocks,
    endpointCost,
    totalCost: submissionCost + endpointCost,
    withinFreeSubmissions: submissions <= FREE_SUBMISSION_ALLOWANCE,
    withinFreeEndpoints: endpoints <= FREE_ENDPOINT_ALLOWANCE,
  };
}

export function formatEuro(amount) {
  return `€${Number(amount).toFixed(2)}`;
}

export function formatCents(rate) {
  const cents = rate * 100;
  const formatted = Number.isInteger(cents) ? String(cents) : cents.toFixed(1).replace(/\.0$/, '');
  return formatted === '1' ? '1 cent' : `${formatted} cents`;
}

export const PRICING_PRESETS = [
  { id: 'small', label: 'Small site', submissions: 50, endpoints: 3 },
  { id: 'medium', label: 'Growing site', submissions: 600, endpoints: 15 },
  { id: 'busy', label: 'Busy site', submissions: 5000, endpoints: 25 },
];
